module.exports = __webpack_public_path__ + "img/9788959065141.dd6c3806.jpg";